import { css } from 'styled-system/css';

export const bettingPreferenceModalStyle = {
	sectionName: css({
		base: {
			zIndex: 101,
		}
	}),
	container: css({
		base: {
			w: '100%',
			maxW: '600px',
			borderRadius: 'var(--border-radius-md)',
			overflow: 'hidden',
			zIndex: 101,
		}
	}),
	header: css({
		base: {
			'--galaxy-header-text': { base: 'var(--p500)', _dark: 'white' },
			color: 'var(--galaxy-header-text)',
			w: '100%',
		},
	}),
	scrollbar: css({
		base: {
			pb: '42px',
			display: 'flex',
			flexDirection: 'column',
			gap: '12px',
		},
		_mars: {
			p: '12px 12px 42px',
		},
	}),
	title: css({
		base: {
			h: '42px',
			fontSize: '14px',
			px: '12px',
			lineHeight: '42px',
			color: 'var(--text-utility-inverse-80-white-100, var(--body-text))',
			bgColor: 'var(--background-neutral-100-400, var(--other-lv3))',
			'--title-color': { base: 'colors.primary.600', _dark: 'colors.whiteOpacity.100' }, 
		},
		_mars: {
			bgColor: 'brand.500_12',
			color: 'var(--title-color)',
			fontWeight: '300',
			borderRadius: '6px 6px 0 0',
		}
	}),
	panel: css({
		_mars: {
			borderRadius: '6px',
			boxShadow: '0 0 0 1px {colors.brand.500_12} inset',
			margin: '0 auto',
			w: '100%',
		}
	}),
	content: css({
		padding: '0 6px',
	}),
	contentHorizontal: css({
		base: {
			display: 'flex',
		}
	}),
	rowItem: css({
		base: {
			display: 'flex',
			padding: '12px',
			cursor: 'pointer',
			w: '100%',
		},
		_mars: {
			borderBottom: '1px solid {colors.black.5}',
			px: '9px',
		}
	}),
	rowRadio: css({
		base: {
			flex: '0 0 auto',
			'& .icon--radio-on': {
				display: 'block',
				color: 'var(--p500)',
			},
		},
		_mars: {
			display: 'none',
		}
	}),
	rowAside: css({
		base: {
			ml: '12px',
		},
		_mars: {
			ml: '0',
			w: '100%',
		}
	}),
	rowTitle: css({
		base: {
			fontSize: '14px',
			fontWeight: 500,	
			lineHeight: '24px',
			color: 'var(--text-utility-inverse-80-white-100, var(--body-text))',
			
		},
		_mars: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			height: '48px',
			px: '9px',
			_active: {
				color: 'brand.500_light',
				'& .icon--ticket-success-line': {
					display: 'block',
				},
			},
		}
	}),
	rowControl: css({
		base: {
			display: 'none',
		},
		_mars: {
			display: 'block',
			width: '24px',
			height: '24px',
			'& .icon--ticket-success-line': {
				display: 'none',
			},
		},
	}),
	rowContent: css({
		base: {
			fontSize: '12px',
			fontWeight: 400,	
			lineHeight: '18px',
		},
		_galaxy: {
			color: 'var(--text-neutral-950-80-050-80, var(--body-text))',
		},
		_mars: {
			backgroundColor: 'var(--other-lv4)',
			color: 'black.2',
			borderRadius: '6px',
			px: '9px',
			py: '9px',
		}
	}),
	columnItem: css({
		base: {
			py: '6px',
			flex: 1,
			display: 'flex',
			flexDir: 'column',
			alignItems: 'center',
			gap: '3px',
			color: 'var(--lv1-50)',
			fontSize: '12px',
			cursor: 'pointer',
			_active: {
				color: 'var(--text-primary-500, var(--p500))', 
			}
		}
	}),
	img: css({
		base: {
			pos: 'relative',
			rounded: '6px',
			borderWidth: '1px',
			borderStyle: 'solid',
			borderColor: 'var(--border-utility-inverse-30, var(--lv1-30))',
			overflow: 'hidden',
			_groupActive: {
				borderColor: 'var(--border-primary-500-54, var(--p500-50))',
				_mars: {
					bgColor: 'primary.500_50'
				}
			}
		},
		_mars: {
			borderColor: 'transparent',
			bgColor: 'black.4',
		}
	}),
	betslipImg: css({
		base: {
			pos: 'absolute',
			top: 0,
			left: 0,
		}
	}),
	betslipTitle: css({
		base: {
			pos: 'absolute',
			top: '50%',
			left: '6px',
			display: 'flex',
			alignItems: 'center',
			color: 'var(--text-utility-inverse-100, var(--lv1-100))',
			transformOrigin: '0 0',
			transform: 'scale(0.7)',
		}
	}),
	betslipBadge: css({
		base: {
			display: 'inline-flex',
			w: '16px',
			h: '16px',
			rounded: '8px',
			lineHeight: '1em',
			alignItems: 'center',
			justifyContent: 'center',
			ml: '3px',
			color: 'var(--text-utility-constant-white-100, var(--lv2-100))',
			bgColor: 'var(--background-utility-inverse-54, var(--lv1-50))',
			_groupActive: {
				bgColor: 'var(--background-primary-500, var(--p500))', 
			}
		}
	}),
	footer: css({
		base: {
			display: 'flex',
			justifyContent: 'center',
			mt: '12px',
			'& .btn': {
				minW: '150px',
				minH: '39px',
			}
		}
	}),
}